import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6","key":"svg-0"}]]

/**
 * IconBrandPolymer
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtcG9seW1lciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNi43MDYgNmwtMy43MDYgNmwzLjcwNiA2aDEuMDU5bDguNDcgLTEyaDEuMDZsMy43MDUgNmwtMy43MDYgNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-polymer
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandPolymer = createReactComponent('outline', 'brand-polymer', 'BrandPolymer', __iconNode);

export default IconBrandPolymer;